// Claymorphism Color Palette (matched with Resume page)
export const claymorphismColors = {
  softOrange: '#FFDAB3',
  softGold: '#FFF3CD',
  softCyan: '#E0F7FA',
  softPeach: '#FDBCB4',
  text: '#1A1A2E',
  textLight: '#424242',
  accent: '#E85D04',
};

export default claymorphismColors;
